import { uploadFileOnPublicApiV2 } from "@common/util";

export const ACTIVITY_FILE_MAX_COUNT = 64;
export const ACTIVITY_FILE_MAX_SIZE = 99 * 1024 * 1024;
export const ACTIVITY_FILE_INVALID_EXTS = ["exe"];

export const ACTIVITY_FILE_SETTINGS = {
  uploader: uploadFileOnPublicApiV2,
  isSingleFile: false,
  maxFiles: ACTIVITY_FILE_MAX_COUNT,
  maxSize: ACTIVITY_FILE_MAX_SIZE,
  invalidFiles: (ext) =>
    ACTIVITY_FILE_INVALID_EXTS.includes(String(ext).toLowerCase()),
  helpText: "",
};

export function isFileField(row) {
  const t = String(row.fieldType || row.FieldType || "").toLowerCase();
  if (t === "file") return true;
  const key = String(row.fieldKey || row.fieldName || "").toLowerCase();
  return /_file(_|$)/.test(key);
}